var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_c('b-card',{staticClass:"mt-3"},[_vm._t("modal-left-button"),_c('b-button',{staticClass:"float-right",attrs:{"size":"sm","variant":_vm.okVariant},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(" "+_vm._s(_vm.okTitle)+" ")])],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }